<script setup lang="ts">
const props = defineProps<{ title: string, desc: string }>();
const device = useDevice();
const items = [
    { title: 'برقراری تماس با اپلیکیشن', cate: 'مرکز تلفن' ,icon: 'solar:buildings-2-linear' },
    { title: 'پیامک انبوه', cate: 'پنل پیامکی' ,icon: 'solar:ticket-linear' },
    { title: 'پیامک شخصی‌سازی', cate: 'پنل پیامکی' ,icon: 'solar:key-linear' },
    { title: 'پیامک گروهی', cate: 'پنل پیامکی' ,icon: 'solar:magnet-wave-linear' },
    { title: 'دریافت پیامک از مخاطبین', cate: 'پنل پیامکی', icon: 'solar:money-bag-linear' },
    { title: 'گزارش ارسال', cate: 'پنل پیامکی', icon: 'solar:box-minimalistic-linear' },
    { title: 'پنل پیامکی لوکیشن‌محور', cate: 'پنل پیامکی', icon: 'solar:laptop-minimalistic-linear' },
    { title: 'ضبط مکالمات', cate: 'مرکز تلفن', icon: 'solar:bill-check-linear' },
    { title: 'گزارش پیشرفته لاگ تما‌س', cate: 'مرکز تلفن', icon: 'solar:bill-check-linear' },
    { title: 'نمودارهای تحلیلی', cate: 'مرکز تلفن', icon: 'solar:headphones-round-sound-linear' },
    { title: 'پیامک تکی', cate: 'پنل پیامکی', icon: 'solar:outgoing-call-rounded-linear' },
    { title: 'مدیریت اسناد مالی', cate: 'سی آر ام', icon: 'solar:chat-round-dots-linear' },
    { title: 'گزارش دریافت', cate: 'پنل پیامکی', icon: 'solar:chat-square-check-linear' },
    { title: 'افزونه وردپرس', cate: 'پنل پیامکی', icon: 'solar:outgoing-call-rounded-linear' },
    { title: 'والبورد', cate: 'مرکز تلفن', icon: 'solar:phone-calling-rounded-linear' },
    { title: 'مشاهده وضعیت کاربران', cate: 'مرکز تلفن', icon: 'solar:buildings-2-linear' },
    { title: 'تعریف صف تماس', cate: 'مرکز تلفن', icon: 'solar:ticket-linear' },
    { title: 'منشی گویا', cate: 'مرکز تلفن', icon: 'solar:key-linear' },
    { title: 'انبارداری', cate: 'سی آر ام', icon: 'solar:magnet-wave-linear' },
    { title: 'ارسال OTP', cate: 'پنل پیامکی', icon: 'solar:money-bag-linear' },
    { title: 'شخصی‌سازی چت‌باکس', cate: 'وب چت', icon: 'solar:box-minimalistic-linear' },
    { title: 'مانیتورینگ زنده تماس‌ها', cate: 'مرکز تلفن', icon: 'solar:laptop-minimalistic-linear' },
    { title: 'سطوح دسترسی', cate: 'مرکز تلفن', icon: 'solar:bill-check-linear' },
    { title: 'تنظیم شروط زمانی', cate: 'مرکز تلفن', icon: 'solar:headphones-round-sound-linear' },
    { title: 'مدیریت وظیفه‌ها', cate: 'سی آر ام', icon: 'solar:outgoing-call-rounded-linear' },
    { title: 'ثبت کالا و خدمات', cate: 'سی آر ام', icon: 'solar:chat-round-dots-linear' },
    { title: 'ارسال پیام متنی نامحدود', cate: 'وب چت', icon: 'solar:chat-square-check-linear' },
    { title: 'ارسال پیام صوتی', cate: 'وب چت', icon: 'solar:outgoing-call-rounded-linear' },
    { title: 'کلیک تو کال', cate: 'سی آر ام', icon: 'solar:phone-calling-rounded-linear' },
    { title: 'دریافت پاپ آپ تماس', cate: 'سی آر ام', icon: 'solar:buildings-2-linear' },
    { title: 'دایورت تماس‌های ورودی', cate: 'مرکز تلفن', icon: 'solar:ticket-linear' },
    { title: 'مدیریت سرنخ‌ها', cate: 'سی آر ام', icon: 'solar:key-linear' },
    { title: 'پیگیری تیکت‌ها', cate: 'سی آر ام', icon: 'solar:magnet-wave-linear' },
    { title: 'تعریف دپارتمان‌ها', cate: 'وب چت', icon: 'solar:money-bag-linear' },
    { title: 'نظرسنجی پایان گفتگو', cate: 'وب چت', icon: 'solar:box-minimalistic-linear' },
    { title: 'حقوق دسترسی', cate: 'مرکز تلفن', icon: 'solar:laptop-minimalistic-linear' },
    { title: 'پروفایل مخاطبین', cate: 'سی آر ام', icon: 'solar:bill-check-linear' },
    { title: 'یکپارچگی با اپلیکیشن', cate: 'سی آر ام', icon: 'solar:headphones-round-sound-linear' },
    { title: 'دریافت نوتیفیکیشن', cate: 'سی آر ام', icon: 'solar:outgoing-call-rounded-linear' },
    { title: 'ارسال فکس اینترنتی', cate: 'فکس', icon: 'solar:chat-round-dots-linear' },
    { title: 'تعریف اپراتور و نقش', cate: 'وب چت', icon: 'solar:chat-square-check-linear' },
    { title: 'دسترسی به تاریخچه گفتگو', cate: 'وب چت', icon: 'solar:outgoing-call-rounded-linear' },
    { title: 'دانلود فایل فکس', cate: 'فکس', icon: 'solar:phone-calling-rounded-linear' },
    { title: 'مشاهده تاریخچه فکس', cate: 'فکس', icon: 'solar:bill-check-linear' },
    { title: 'آرشیو خودکار فکس‌ها', cate: 'فکس', icon: 'solar:headphones-round-sound-linear' },
    { title: 'ارائه وب هوک و API', cate: 'فکس', icon: 'solar:outgoing-call-rounded-linear' },
    { title: 'دریافت فکس آنلاین', cate: 'فکس', icon: 'solar:chat-round-dots-linear' },
    { title: 'دریافت پیام در اپلیکیشن', cate: 'وب چت', icon: 'solar:chat-square-check-linear' },
    { title: 'داشبورد یکپارچه مدیریتی', cate: 'وب چت', icon: 'solar:outgoing-call-rounded-linear' },
];
</script>

<template>
    <SectionsBase class="container bg-linear-to-r from-white via-primary-50 to-white">
        <ChipsDivider>امکانات</ChipsDivider>
        <h2>{{ props.title }}</h2>
        <p class="text-body1-semibold text-gray-400 text-center mt-6 mb-8">{{ props.desc }}</p>
        <ClientOnly>
            <LazySectionsFacilitiesHomeMobile 
                v-if="!device.isDesktop.value"
                :items="items" 
            />
            <LazySectionsFacilitiesHomeDesktop 
                v-else
                :items="items" 
            />
        </ClientOnly>
    </SectionsBase>
</template>